import { render, staticRenderFns } from "./Sms.vue?vue&type=template&id=af2a0d9c&scoped=true"
import script from "./Sms.vue?vue&type=script&lang=js"
export * from "./Sms.vue?vue&type=script&lang=js"
import style0 from "./Sms.vue?vue&type=style&index=0&id=af2a0d9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af2a0d9c",
  null
  
)

export default component.exports